<!--
발송작업 > 지난 발송내역
-->
<template>
    <div class="uk-flex" :class="rootClass">
        <a class="title" target="_blank" :href="'/prods/' + shipProd.id + '/out-req-info'" title="새창에서 상세내역 확인">
            <i class="material-icons">list</i>
            발송실패 기록({{ oldReqs.length }})
        </a>
        <div class="body uk-width-expand">
            <table class="req-info">
                <tr>
                    <th>작업일시</th>
                    <th>요청사항</th>
                    <th>작업메모</th>
                </tr>

                <tr v-for="(req, index) in oldReqs" :key="index">
                    <td class="">
                        {{ req.job_at ? moment(req.job_at).format('YYYY-MM-DD') : null }}
                    </td>
                    <td class="">
                        {{ req.req_memo }}
                    </td>
                    <td class="">
                        {{ req.job_memo }}
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import moment from "moment/moment";

export default {
    components: {},
    props: {

        // shipProd
        shipProd: Object,

        // 지난 발송내역
        oldReqs: Array,
    },
    data: function () {
        return {};
    },
    computed: {
        moment() {
            return moment
        },
        // 클래스명
        rootClass() {
            return {
                empty: this.oldReqs.length === 0,
            };
        },

    },
    methods: {},
}
</script>

<style lang="scss" scoped>
.title {
    display: block;
    text-align: left;
    width: 12rem;
    color: #000;
    font-size: 1.25rem;

    margin-right: 2rem;

    .material-icons {
        font-size: 1.75rem;
    }
}

.empty .title {
    color: #999;
}

// 테이블
table.req-info {
    width: auto;
    border-collapse: collapse;
    border-spacing: 0;

    th, td {
        text-align: left;
        border: 1px solid #cfcfcf;
        font-weight: normal;

        padding: 5px;
        color: #000;

        font-size: 1rem;
    }

    th {
        background-color: #fafafa;

    }

    td {
        font-size: 1.25rem;
    }

}

</style>